export default "__VITE_ASSET__8c0e1462__"